/**
 * Push notification configuration — wire up Firebase Cloud Messaging or OneSignal.
 *
 * Firebase: set REACT_APP_FCM_VAPID_KEY (Web Push certificate public key)
 * OneSignal: set REACT_APP_ONESIGNAL_APP_ID
 */

export const PUSH_PROVIDER = (() => {
  if (process.env.REACT_APP_ONESIGNAL_APP_ID) return "onesignal";
  if (process.env.REACT_APP_FCM_VAPID_KEY) return "fcm";
  return null;
})();

export const FCM_VAPID_KEY = String(process.env.REACT_APP_FCM_VAPID_KEY || "").trim();
export const ONESIGNAL_APP_ID = String(process.env.REACT_APP_ONESIGNAL_APP_ID || "").trim();

export function isPushConfigured() {
  return Boolean(PUSH_PROVIDER);
}
